import { useRequest } from "@onefront/react-sdk";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { CodeBox } from "../CodeBox";

export const MockRequest = ({ exampleUrl }) => {
  const { loading, data, error, fetch } = useRequest({
    lazy: true,
    method: "get",
    url: "random://number"
  });

  return (
    <Box sx={{ mb: "20px" }}>
      <ExtendedTypography variant="titleSmall">
        useRequest for an API mocked by Proxy
      </ExtendedTypography>
      <CodeBox>
        {`
const { loading, data, error, fetch } = useRequest({
  lazy:   true,
  method: "get",
  url:    "random://number"
});
        `.trim()}
      </CodeBox>
      <Box
        sx={{ display: "flex", flexDirection: "row", alignItems: "baseline" }}
      >
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={fetch}
          disabled={loading}
        >
          Click me
        </Button>
        {loading && "Loading random number..."}
        {error && `ERROR: ${error.message}`}
      </Box>
      {data && <CodeBox>{data.value}</CodeBox>}
    </Box>
  );
};
